import { render, staticRenderFns } from "./App.vue.js?vue&type=template&id=60afd49e!=!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=60afd49e"
import script from "./App.vue.js?vue&type=script&lang=js!=!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=script&lang=js"
export * from "./App.vue.js?vue&type=script&lang=js!=!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports